/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sponsor_Edit_Search_LabelInputs */



/**
* | output |
* | --- |
* | "Search for the sponsoring member" |
*
* @param {Sponsor_Edit_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_search_label = /** @type {((inputs?: Sponsor_Edit_Search_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_Search_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher le membre parrain")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar al miembro avalista")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Procurar o membro padrinho")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca il membro sponsor")
	return /** @type {LocalizedString} */ ("Search for the sponsoring member")
});